class Main15DadSurvey extends HTMLElement {
  constructor() {
    super();

    this.redirects = {
      first_no_dd_url: encodeURI(this.dataset.redirectFirstNoDd),
      no_little_progress_url: encodeURI(this.dataset.redirectNoLittleProgress),
      good_progress_url: encodeURI(this.dataset.redirectGoodProgress),
      great_progress_url: encodeURI(this.dataset.redirectGreatProgress),
    };

    this.email = decodeURIComponent(this.dataset.email);
    this.token = this.dataset.token;
    this.customerName = this.dataset.customerName;
    this.dogName = this.dataset.dogName;
    this.dogWeight = this.dataset.dogWeight;
    this.initialScore = this.dataset.initialScore;

    this.tagHeading = this.dataset.tagHeading.replace(/\s+/g, '');
    this.surveyInputs = {};
    this.surveyInputs[`${this.tagHeading}current-total-score`] = 0;

    this.setUpEventListeners();
  }

  setUpEventListeners() {
    document.addEventListener('DOMContentLoaded', this.onInit.bind(this));

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', this.onSectionLoad.bind(this));
    }

    this.querySelectorAll("input:not([type='submit'])").forEach((input) => {
      if (input.type === 'radio') {
        input.addEventListener('click', this.onTabChange.bind(this));
      }
    });

    this.querySelectorAll('form').forEach((form) => {
      form.addEventListener('submit', this.onFormSubmit.bind(this));
    });

    this.querySelectorAll('survey-back').forEach((backBtn) =>
      backBtn.addEventListener('click', this.onBackClick.bind(this))
    );
  }

  onInit() {
    const surveyFirstStep = this.querySelector("survey-step[survey-step-index='0']");
    const surveyTextInputs = this.querySelectorAll("input[type='text'], input[type='number'], input[type='email']");

    setTimeout(() => {
      surveyTextInputs.forEach((input) => {
        const thisInputBtn = input.closest('survey-step');

        this.toggleSubmitButton(thisInputBtn, input.value.trim() !== '');
      });
    }, 500);

    this.animateElementBlocks(surveyFirstStep);
    this.updateDogName(this.dogName);
  }

  onSectionLoad() {
    this.querySelectorAll('survey-step').forEach((step) => {
      step.style.display = 'block';

      step.querySelectorAll('[animate-fade-in]').forEach((element) => {
        element.removeAttribute('animate-fade-in');
      });
    });
  }

  getCurrentStep(event) {
    return event.target.closest('survey-step');
  }

  onTabChange(event) {
    const currentStep = this.getCurrentStep(event);
    const submitButton = currentStep.querySelector("input[type='submit']");
    const labels = currentStep.querySelectorAll('label');

    if (submitButton === null) {
      labels.forEach((label) => label.toggleAttribute('disabled', true));

      setTimeout(() => {
        this.onFormSubmit(event);
        labels.forEach((label) => label.toggleAttribute('disabled', false));
      }, 600);
    } else {
      this.toggleSubmitButton(this.getCurrentStep(event), true);
    }
  }

  toggleSubmitButton(currentStep, enable) {
    const submitButton = currentStep.querySelector("input[type='submit']");

    submitButton !== null ? submitButton.toggleAttribute('disabled', !enable) : null;
  }

  onFormSubmit(event) {
    event.preventDefault();

    const form = event.target.closest('form');
    const formData = new FormData(form);
    const formDataJson = {};
    const currentStep = this.getCurrentStep(event);

    const checkedInput = form.querySelector("input[type='radio']:checked");
    const score = checkedInput.dataset.score ? parseInt(checkedInput.dataset.score) : null;

    formData.forEach((value, key) => {
      formDataJson[key] = formDataJson[key] ? [].concat(formDataJson[key], value) : value;
    });

    score && (this.surveyInputs[`${this.tagHeading}current-total-score`] += score);

    Object.assign(this.surveyInputs, formDataJson);
    this.navigateStep(currentStep, 'next');
  }

  navigateStep(currentStep, direction) {
    const currentStepIndex = currentStep?.getAttribute('survey-step-index');
    const targetStep = direction === 'next' ? currentStep.nextElementSibling : currentStep.previousElementSibling;
    const targetIndex = targetStep?.getAttribute('survey-step-index');

    if (targetIndex) {
      currentStep.style.display = 'none';
      targetStep.style.display = 'flex';

      this.animateProgressBar(targetIndex);
      this.animateElementBlocks(targetStep);
    } else if (currentStepIndex === 'last') {
      this.surveyFinalStep();
    }
  }

  onBackClick(event) {
    this.navigateStep(this.getCurrentStep(event), 'prev');
  }

  updateDogName(dogName) {
    const dogNameElement = this.querySelectorAll('[dog-name]');
    const dogNameFormatted = dogName.replace(/^(\w)(.+)/, (match, p1, p2) => p1.toUpperCase() + p2.toLowerCase());

    dogNameElement.forEach((el) => (el.textContent = dogNameFormatted));
  }

  animateElementBlocks(targetStep) {
    const animatedBlocks = targetStep.querySelectorAll('[animate-fade-in]');
    const delay = 200;

    animatedBlocks.forEach((block, index) => {
      setTimeout(() => {
        block.removeAttribute('animate-fade-in');
      }, index * delay);
    });
  }

  animateProgressBar(targetIndex) {
    const progressBar = this.querySelector('survey-progress');
    const progressBarInner = progressBar.querySelector('[survey-progress-inner]');
    const progressBarText = this.querySelector('[survey-progress-text]');

    const surveyCount = this.querySelectorAll('survey-step').length - 1;
    const currentProgress =
      targetIndex !== 'last' ? Math.round((100 / surveyCount) * Number(targetIndex)) + '%' : '100%';

    progressBar.style.display = progressBar.style.display === 'none' ? 'block' : progressBar.style.display;
    window.requestAnimationFrame(function () {
      progressBarInner.style.width = currentProgress;
      progressBarText.textContent = currentProgress;
    });
  }

  surveyFinalStep() {
    const currentScore = this.surveyInputs[`${this.tagHeading}current-total-score`];
    const scoreRanges = [
      { min: 0, max: 119, value: 'Severe Joint Issues' },
      { min: 120, max: 209, value: 'Moderate Joint Issues' },
      { min: 210, max: 300, value: 'Mild Joint Issues' },
    ];

    const jointIssueRange = scoreRanges.find((range) => currentScore >= range.min && currentScore <= range.max);
    this.surveyInputs[`${this.tagHeading}joint-issue`] = jointIssueRange.value;

    this.redirectPage();
  }

  redirectPage() {
    const iteration = parseInt(this.dataset.currentIteration);
    const improvements = this.surveyInputs[`${this.tagHeading}joint-health-improving`];
    const currentScore = this.surveyInputs[`${this.tagHeading}current-total-score`];
    const hasSeenEnhancementBundleOffer = this.dataset.hasSeenEnhancementBundle == 'true' ? true : false;
    const baseUrl =
      iteration === 1
        ? this.redirects.first_no_dd_url
        : {
            'not-at-all': this.redirects.no_little_progress_url,
            'minor-improvements': this.redirects.no_little_progress_url,
            'moderate-improvements': this.redirects.good_progress_url,
            'major-improvements': this.redirects.great_progress_url,
          }[improvements] || null;

    const params = {
      'current-iteration': iteration,
      'initial-score': this.initialScore,
      'current-score': currentScore,
      'has-seen-enhancement-bundle': hasSeenEnhancementBundleOffer,
      'customer-name': this.customerName,
      'dog-name': this.dogName,
      'dog-weight': this.dogWeight,
      email: this.email,
      token: this.token,
    };

    const queryString = new URLSearchParams(params).toString();
    const redirectUrl = `${baseUrl}?${queryString}`;

    this.sendDataToKlaviyo(redirectUrl, iteration);
  }

  async sendDataToKlaviyo(redirectUrl, iteration) {
    const currentSurveyResults = {};
    klaviyo.push(['identify', { $email: this.email }]);

    const eventData = {
      $email: this.email,
      dog_name: this.dogName,
      customer_name: this.customerName,
      iteration,
      current_score: this.surveyInputs[`${this.tagHeading}current-total-score`],
      joint_issue: this.surveyInputs[`${this.tagHeading}joint-issue`],
      has_seen_enhancement_bundle: this.dataset.hasSeenEnhancementBundle === 'true',
    };

    Object.keys(this.surveyInputs).forEach((key) => {
      eventData[key] = this.surveyInputs[key];
    });

    klaviyo.push(['track', 'Submitted 15 Days After Delivery Survey', eventData]);

    const autoSubscribeEmail = !!this.klaviyoListID;
    const KLdata = autoSubscribeEmail
      ? {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.email,
                  properties: {},
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.klaviyoListID,
              },
            },
          },
        }
      : {
          type: 'profile',
          attributes: {
            email: this.email,
            properties: {},
          },
        };

    Object.keys(this.surveyInputs).forEach((name) => {
      if (name != `${this.tagHeading}current-total-score`) {
        currentSurveyResults[`${name}--current`] = this.surveyInputs[name];
      }
    });

    if (iteration === 1) {
      Object.keys(this.surveyInputs).forEach((name) => {
        if (name != `${this.tagHeading}current-total-score`) {
          currentSurveyResults[`${name}--initial`] = this.surveyInputs[name];
        }
      });
    }

    currentSurveyResults[`${this.tagHeading}current-total-score`] =
      this.surveyInputs[`${this.tagHeading}current-total-score`];

    const KLdataAttributes = autoSubscribeEmail ? KLdata.attributes.profile.data.attributes : KLdata.attributes;
    const klaviyoAPIFetchURL = autoSubscribeEmail
      ? 'https://a.klaviyo.com/client/subscriptions?company_id=SQEMbF'
      : 'https://a.klaviyo.com/client/profiles/?company_id=SQEMbF';

    Object.keys(currentSurveyResults).forEach((name) => {
      KLdataAttributes.properties[name] = currentSurveyResults[name];
    });

    KLdataAttributes.properties[`${this.tagHeading}has-seen-enhancement-bundle`] = iteration > 1;
    KLdataAttributes.properties[`${this.tagHeading}iteration`] = iteration;
    KLdataAttributes.properties['$source'] = '15 days after delivery survey';
    KLdataAttributes.properties['source_handle'] = '15-dad-survey';

    const KLoptions = {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        revision: '2024-10-15',
      },
      body: JSON.stringify({ data: KLdata }),
    };

    await fetch(klaviyoAPIFetchURL, KLoptions).catch((err) => console.error(err));

    location.href = redirectUrl;
  }
}

customElements.define('main-15-dad-survey', Main15DadSurvey);
